<div class="box ml-2 mr-2">
  <div class="box-header">

    <div class="box-body">
      <form [formGroup]="marForm">
        <div class="col form">
          <div class="row" style="justify-content: center;">


            <div class="col">


              <mat-form-field appearance="outline">
                <mat-label>{{'From Date' | translate}}</mat-label>
                <input matInput [max]="maxDate" [matDatepicker]="picker" formControlName="fromDate">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>




            </div>

            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{'To Date' | translate}}</mat-label>
                <input matInput  [max]="maxDate" [matDatepicker]="todate" formControlName="toDate">
                <mat-datepicker-toggle matSuffix [for]="todate"></mat-datepicker-toggle>
                <mat-datepicker #todate></mat-datepicker>
              </mat-form-field>



            </div>

            @if (userData.roleId<4) {
              <div class="col">
                <!-- <mat-form-field appearance="outline">
                <mat-label>{{'DC Location' | translate}}</mat-label>
                <input matInput maxlength="6" formControlName="storeNumber" (keyup.enter)="getPOOrderData()" />
              </mat-form-field> -->
              <mat-form-field class="example-full-width" appearance="outline" >
                <mat-label>{{'DC Location' | translate}}</mat-label>
                <input maxlength="20" type="text" matInput formControlName="dcNumber" [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                  @for (dc of user.dcLocations; track dc) {
                    <mat-option [value]="dc.dcNumber">
                      {{dc.dcLocation}} - {{dc.dcName}}
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
          }


          <div class="col">

            <button mat-raised-button class="ml-2 mt-3 ml-sm-auto" (click)="generateMarReport()" [disabled]="!marForm.valid">
              {{'Filter' | translate}}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>


</div>


</div>